const inViewPort = (el) => {
  const bounding = el.getBoundingClientRect()
  const inView =
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)

  if (inView) {
    return true
  }

  return false
}

export const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

export const track = ({ e, type, value }) => {
  /*eslint-disable */
  if (window.gtag === undefined) {
    return console.log("Event Tracking: Unable to track event, gtag is missing.")
  }

  value ??= 1

  switch (type) {
    case "lead":
      gtag("event", "generate_lead", {
        value,
        currency: "USD",
      })
      break
    case "focus_form":
      gtag("event", "focus_form")
      break
    case "begin_form":
      gtag("event", "begin_form")
      break
    default:
      console.log("Event Tracking: An event type must be provided!")
      break
  }
  /*eslint-enable */
}

/* Format phone number */
export const formatPhone = (str) => {
  let x = str.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
  str = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "")
  console.log(str)
  return str
}

export const focusForm = (e, formID) => {
  e.preventDefault()
  track({ e, type: "focus_form" })
  const form = document.querySelector(formID)
  const childField = form.querySelector("input")
  form.scrollIntoView({ behavior: "smooth" })

  document.addEventListener("scroll", () => (inViewPort(form) ? childField.focus() : false))
}
